/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Bullet_Move_UpInputs */



/**
* | output |
* | --- |
* | "Move bullet up" |
*
* @param {Presentation_Bullet_Move_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_bullet_move_up = /** @type {((inputs?: Presentation_Bullet_Move_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Bullet_Move_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufzählungspunkt nach oben")
	return /** @type {LocalizedString} */ ("Move bullet up")
});